var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditQuote',{attrs:{"title":"Rideshare - Edit Quote","productType":"ride-protect"}})}
var staticRenderFns = []

export { render, staticRenderFns }